function formatDate(date) {
  const originalDate = new Date(date);
  if (!date || originalDate === "Invalid Date") {
    return "";
  }
  return originalDate.toLocaleDateString("en-GB");
}

export default formatDate;
